import axiosClient from "../../../../../system/helpers/axiosConfig";

export const getAdminMails = (type, params) => {
  return axiosClient
    .get(`/api/admin/im/${type}`, { params })
    .then((r) => r.data);
};
